import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmationDialog(props) {
    const { open, title, message, onConfirm, onCancel } = props;
  
  const handleConfirm = () => {
    onConfirm();
  };
  const handleCancel = () => {
    onCancel();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='secondary' onClick={handleConfirm}>Confirm</Button>
          <Button onClick={handleCancel} autoFocus>
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}